import Landing from "./landing";

export const LandingPage = Landing;

